exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .new-parts-subtotal {\n  border-top: 1px solid #dddddd;\n  padding: 15px 16px 0 15px;\n  margin: 0 -16px;\n  text-align: right;\n}\n\n.pc .new-parts-subtotal .subtotal {\n  font-family: \"JDSansPro-Medium\", \"Helvetica Neue\", \"Roboto\", helvetica, arial, sans-serif;\n  font-size: 17px;\n  font-weight: bold;\n}\n\n.pc .new-parts-subtotal .subtotal .price-display .price {\n  font-size: 17px;\n}\n\n.pc .new-parts-subtotal .dealer-message {\n  font-size: 12px;\n}\n\n", ""]);

// exports
